import { Link } from "react-router-dom";

export default function SmsConsent({ checked, onChange, context = "booking", testId = "sms-consent-checkbox" }) {
  return (
    <div className="space-y-1.5">
      <label className="flex items-start gap-2 cursor-pointer select-none" data-testid={`${testId}-label`}>
        <input
          type="checkbox"
          data-testid={testId}
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="mt-0.5 h-4 w-4 shrink-0 rounded border-zinc-400 accent-[#0C2E2B]"
        />
        <span className="text-[11px] leading-snug text-zinc-600">
          Yes, text me updates about my {context} from Harvey's Place. Msg frequency varies; msg &amp; data rates may apply.
          Reply <b>STOP</b> to opt out, <b>HELP</b> for help. Optional.
        </span>
      </label>
      <p className="text-[10px] text-zinc-500 leading-snug" data-testid={`${testId}-terms-note`}>
        By submitting you agree to our{" "}
        <Link to="/terms" target="_blank" className="underline font-semibold text-[#0C2E2B]">Terms</Link>,{" "}
        <Link to="/terms#privacy" target="_blank" className="underline font-semibold text-[#0C2E2B]">Privacy Policy</Link>,{" "}
        <Link to="/terms#delivery" target="_blank" className="underline font-semibold text-[#0C2E2B]">Delivery &amp; Transport Terms</Link>{" "}
        and <Link to="/terms#sms" target="_blank" className="underline font-semibold text-[#0C2E2B]">SMS Terms</Link>.
      </p>
    </div>
  );
}
